import { render, staticRenderFns } from "./Selete.vue?vue&type=template&id=3cb3923c&scoped=true"
import script from "./Selete.vue?vue&type=script&lang=js"
export * from "./Selete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb3923c",
  null
  
)

export default component.exports